import { render, staticRenderFns } from "./txRequest.vue?vue&type=template&id=dfec5a4e&scoped=true&"
import script from "./txRequest.vue?vue&type=script&lang=js&"
export * from "./txRequest.vue?vue&type=script&lang=js&"
import style0 from "./txRequest.vue?vue&type=style&index=0&id=dfec5a4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfec5a4e",
  null
  
)

export default component.exports